module.exports = "<fuse-main></fuse-main>\n"